import type { FC } from 'react';
import type { Control } from 'react-hook-form';
import { useSalesforceConnect } from '../../../../../../../hooks/requests/use-salesforce';
import { IntegrationFooter } from '../../../components/IntegrationFooter';
import type { SalesforceRegisterFormValues } from '../SalesforceRegisterFormSchema';

type SalesforceFooterProps = {
  control: Control<SalesforceRegisterFormValues>;
};

export const SalesforceFooter: FC<SalesforceFooterProps> = ({ control }) => {
  const mutateAsyncSalesforceConnect = useSalesforceConnect();

  return (
    <IntegrationFooter
      control={control}
      mutate={mutateAsyncSalesforceConnect}
      buttonLabel="Connect to Salesforce"
      toastMessages={{ pending: 'Connecting...', success: 'Connected', error: 'Failed to connect' }}
    />
  );
};
